import { useTranslation } from "react-i18next";
import { ProfileFullNames, typeStateCategories } from "../Layout";
import React from "react";
import { PreviewControl } from "./PreviewControl";
import { Ups } from "../Ups";
import { FormControl } from "../Form/FormControl";

interface TopContainerProps extends typeStateCategories{
    modelShortNames: string[];
}
export const TopContainer = (props: TopContainerProps) => {
    const { state, modelShortNames } = props;
    const [ selectedShortName, setSelectedShortName ] = React.useState<string>('Lia');
    const [category] = state;
    const { t } = useTranslation();

    return (
        <>
            <div id={'top_container'} className="top-container box">
            {category === 'videos' && (
                <h2 className="text-align-center">{t('Deine Top Video-Models')}</h2>
            )}
                {category === 'livecams' && (
                    <h2 className="text-align-center">{t('Deine Top 5 Live-Models')}</h2>
                )}
                {category === 'chatting' && (
                    <h2 className="text-align-center">{t('Deine Top Chat-Models')}</h2>
                )}
                {category === 'videos' && (
                    <p className="text-align-center">{t('Wähle dein Lieblingsmodel aus - das Video und der Inhalt passen sich automatisch an')}</p>
                )}
                <div className="grid-odd-5">
                    {modelShortNames.map((shortName, index) =>
                    <div 
                        key={index} 
                        style={{gridArea:`profile${index+1}`}} 
                        className={`profile-model ${category === 'videos' ? 'hover' : ''}`} 
                        onClick={ category === 'videos' ? () => setSelectedShortName(shortName) : undefined}>
                        <img key={index} src={`js/img/PB_${shortName}.jpg`} alt={`Model ${index + 1}`} className="model-image" />
                        <div className="status-container">
                            <div className="status"></div>
                        </div>
                        <p className="model-name text-align-center">{ProfileFullNames[shortName as keyof typeof ProfileFullNames]}</p>
                    </div>
                    )}
                </div>
            </div>
            <div className="margin-top-2">
                    <PreviewControl selectedShortName={selectedShortName} state={state} />
            </div>
            <Ups state={state} selectedShortName={selectedShortName} />
            <FormControl state={state} selectedShortName={selectedShortName} />
        </>
    )
}
